import { ref, computed } from 'vue';

export const ALL_GROWERS = '__all__';

function growerKey(grower) {
	return grower && grower.name ? grower.name.trim() : '';
}

function getUniqueGrowers(samples) {
	const seen = new Map();
	(samples || []).forEach(s => {
		const key = growerKey(s.grower);
		if (key && !seen.has(key)) seen.set(key, s.grower);
	});
	return Array.from(seen.values());
}

export function useGrowerFilter(allSamples) {
	const selectedGrower = ref(ALL_GROWERS);

	const growers = computed(() => getUniqueGrowers(allSamples.value));

	const filteredSamples = computed(() => {
		if (!selectedGrower.value || selectedGrower.value === ALL_GROWERS) {
			return allSamples.value;
		}
		return allSamples.value.filter(s => growerKey(s.grower) === selectedGrower.value);
	});

	function selectGrower(key) {
		selectedGrower.value = key;
	}

	function resetFilter() {
		selectedGrower.value = ALL_GROWERS;
	}

	return { selectedGrower, growers, filteredSamples, selectGrower, resetFilter, growerKey };
}
